import { createReducer, on } from '@ngrx/store';
import { setFundChartSortDirection } from './sort-direction.actions';
import { updateFundChartSecurityOrdering } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
export const sortDirection = createReducer('', on(setFundChartSortDirection, (state, action) => {
    return action.sortDirection;
}), on(updateFundChartSecurityOrdering, () => {
    return '';
}));
